package com.fireavert.reports_page.reports_page.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class DeviceToEventRatioResponse(
    val eventCount: Array<Int>,
    val offlineEventCount: Array<Int>
)
